import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsExceptionActionRequestImplEncoder } from "../../encoder/OpsExceptionActionRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OpsExceptionActionRequest } from "../OpsExceptionActionRequest";

export class OpsExceptionActionRequestImpl
  extends ConcreteEncodable
  implements OpsExceptionActionRequest
{
  public static enType: string = "com.bcdfx.model.event.OpsExceptionActionRequestImpl";

  /*FID=1*/
  public repriceOrders: Array<CubiqTS.OpsExcClearingData> | null = null;
  /*FID=2*/
  public cancelOrders: Array<CubiqTS.OpsExcClearingData> | null = null;
  /*FID=3*/
  public resendDeals: Array<CubiqTS.OpsExcClearingData> | null = null;
  /*FID=4*/
  public clearing: Array<CubiqTS.OpsExcClearingData> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsExceptionActionRequestImplEncoder.Instance;
    this.setEncodableType(OpsExceptionActionRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OpsExceptionActionRequestImpl[" +
      "repriceOrders=" +
      this.repriceOrders +
      "cancelOrders=" +
      this.cancelOrders +
      "resendDeals=" +
      this.resendDeals +
      "clearing=" +
      this.clearing +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
